import { ref } from 'vue';
export default {
  name: 'KpiTypeSelect',
  setup(props, {
    emit
  }) {
    const rows = ref([{
      value: 0,
      label: '[请选择指标类型]'
    }, {
      value: 1,
      label: '项目绩效指标'
    }, {
      value: 2,
      label: '部门整体支出绩效指标'
    }]);
    return {
      rows
    };
  }
};